const translations = {
    delete: 'Delete',
    view: 'View'
};

export default translations;
